
import React, { useEffect, useState, useRef } from "react";
import { useIsMobile } from "../../hooks/useIsMobile";
import { useLocation, useParams } from "react-router-dom";
import { BeatLoader } from 'react-spinners';
import BookPageLayout from "./BookPageLayout";
import { useBookData } from "./hooks/useBookData";
import usePageTitle from "../../hooks/usePageTitle";
import { trackEvent } from '../../lib/analytics';
import Alert from "../../common/layouts/modal/Alert";



const BookPageContainer = () => {
    const { bookId } = useParams();
    const location = useLocation();
    const id = bookId || location.state?.bookData?.bookId;
    const isMobile = useIsMobile();
    const viewedRef = useRef('');

    useEffect(() => {
        if (!id) return;

        if (viewedRef.current === String(id)) return;
        viewedRef.current = String(id);

        trackEvent('view_book_detail', {
            book_id: String(id),
            page_path: window.location.pathname,
        });
    }, [id]);

    const { bookData, loading, likeCount, handleLike } = useBookData(id);
    const [showDeactivatedAlert, setShowDeactivatedAlert] = useState(false);

    const handleLikeClick = async () => {
        const currentStatus = localStorage.getItem("authorStatus");
        if (currentStatus && currentStatus.toLowerCase() === "hold") {
            setShowDeactivatedAlert(true);
            return;
        }
        await handleLike();
    };

    const bookTitle = bookData?.bookTitle;
    const authorName = bookData?.author?.authorName;
    const pubReason = bookData?.bookPublicationReason;

    const seoTitle = bookTitle && authorName 
        ? `${bookTitle} | ${authorName}` 
        : bookTitle 
            ? `${bookTitle} | 북밋` 
            : "북밋 도서 상세페이지";

    const seoDescription = pubReason 
        ? (pubReason.length > 150 ? `${pubReason.substring(0, 150)}...` : pubReason)
        : bookTitle 
            ? `${bookTitle} 작품 소개를 북밋에서 확인해보세요.` 
            : undefined;

    usePageTitle(
        seoTitle,
        seoDescription,
        !loading && !!bookData
    );

    if (loading) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                backgroundColor: 'white'
            }}>
                <BeatLoader color="#19CF7A" size={15} />
            </div>
        );
    }

    if (!bookData) {
        return (
            <div>책 정보를 불러올 수 없습니다.</div>
        );
    }

    return (
        <>
            <BookPageLayout
                bookData={bookData}
                onLike={handleLikeClick}
                likeCount={likeCount}
                isMobile={isMobile}
            />
            {showDeactivatedAlert && (
                <Alert
                    title="알림"
                    message={`현재 계정 이용이 제한된 상태입니다.\n운영 정책 위반으로 인해\n작품 좋아요 기능이 제한되었습니다.\n기존 게시글은 수정 후 안내 메일에 따라 재검토 요청이 가능합니다.`}
                    onClose={() => setShowDeactivatedAlert(false)}
                />
            )}
        </>
    );

}

export default BookPageContainer;
